module.exports = __webpack_public_path__ + "static/media/discover-incentives-card.1ae81515.png";